const flag = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M4%2023V21H5V1H7V2H21.1247L18.126%207.99991L21.126%2014H7V21H8V23H4ZM17.8893%204H7V12H17.89L15.89%208.00009L17.8893%204Z'/%3e%3c/svg%3e";
export {
  flag as default
};
//# sourceMappingURL=flag.svg.es.js.map
